import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { Paper } from '@mui/material';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';

/**
 * @name AudioContextPlayerVolume
 * @description This component is an editor for the audioContextPlayerVolume configuration.
 *
 * audioContextPlayerVolume: {
 *   "enabled": true
 * }
 *
 * @param {{keyData: 'experimentalFeaturesData.audioContextPlayerVolume'}} keyData
 */
const AudioContextPlayerVolume = ({ keyData, featureDescription }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Audio Context Player Volume"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Audio Context Player Volume']}
				description="Manage Audio Context Player Volume Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>

			<CheckBoxInput
				keyData={keyData + '.enabled'}
				label="Enabled"
				disabled={false}
				containerStyles={{ marginTop: '6rem', marginLeft: '5rem', width: 'fit-content' }}
				defaultChecked={false}
				object={rawConfig}
				updateObject={updateRawConfig}
			/>
		</Paper>
	);
};

export default AudioContextPlayerVolume;
